/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo, useLayoutEffect, useEffect, useState } from "react";
import objectPath from "object-path";
import { NavLink, useLocation } from "react-router-dom";
import { getBreadcrumbsAndTitle, useSubheader } from "../../_core/MetronicSubheader";
import { useHtmlClassService } from "../../_core/MetronicLayout"
import EnableStudio from './enableStudio'
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { getInitialRoute } from "../../../../../../../../utils";
import { useDispatch } from "react-redux";
import { getWidgetWallData } from "../../../../../../../../actions/wallDataAction";
import { FontAwesomeIcon } from "../../../../../../../CommonComponents/AssetsHelper";

export function SubHeader(props) {
  const uiService = useHtmlClassService();
  const location = useLocation();
  const subheader = useSubheader();
  const dispatch = useDispatch()
  // const layoutProps = useMemo(() => {
  //   return {
  //     config: uiService.config,
  //     subheaderMobileToggle: objectPath.get(
  //       uiService.config,
  //       "subheader.mobile-toggle"
  //     ),
  //     subheaderCssClasses: uiService.getClasses("subheader", true),
  //     subheaderContainerCssClasses: uiService.getClasses(
  //       "subheader_container",
  //       true
  //     )
  //   };
  // }, [uiService]);

  useLayoutEffect(() => {
    const aside = getBreadcrumbsAndTitle("kt_aside_menu", location.pathname);
    const header = getBreadcrumbsAndTitle("kt_header_menu", location.pathname);
    const breadcrumbs = (aside && aside.breadcrumbs.length > 0) ? aside.breadcrumbs : header.breadcrumbs;
   // subheader.setBreadcrumbs(breadcrumbs);
    //subheader.setTitle((aside && aside.title && aside.title.length > 0) ? aside.title : header.title);
    // eslint-disable-next-line
  }, [location.pathname]);

  // Do not remove this useEffect, need from update title/breadcrumbs outside (from the page)
  useEffect(() => { }, [subheader]);

  return (
    <div id="kt_subheader" className={`subheader`}>
      <div className={`f-between flex-wrap pe-3`}>
        {/* Info */}
        <div className="d-flex align-items-center">
          <NavLink className="p-3 border-end me-3" onClick={()=>dispatch(getWidgetWallData(localStorage.getItem('ownerId'), props.wallID))} to={`/wall/index/${props.wallID}`}>
            <FontAwesomeIcon type={'regular'} icon={'angle-left'} iconClass={'fs-5'} />
          </NavLink>  <h5 className="my-3">Studio</h5>
        </div>
        {/* Toolbar */}
        <div className="d-flex align-items-center" style={{ color: '#2B2B2B', display: 'flex' }}>
          Enable Studio
          <EnableStudio {...props} />
        </div>

        {/* <span className="switch switch-success switch-sm">
            <label>
              <input type="checkbox" checked="checked" name="select" />
              <span></span>
            </label>
          </span> */}

      </div>
    </div>
  );
}
